import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Flex,
  Text,
  Box,
  Tooltip,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Grid,
  Heading,
} from "@chakra-ui/react";

import { FaArrowDown, FaArrowUp, FaEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { AiFillEye } from "react-icons/ai";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";

// import UserEditModal from "./UserEditModal";
import RolesModal from "./BsesRolesModal";
import DeleteModal from "components/layouts/MainWindow/Admin/DeleteModal";

import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";

// import Pagination from "components/common/Pagination/pagination";
import _ from "lodash";
import { HiOutlineRefresh } from "react-icons/hi";
import { Paginationlimit } from "components/common/functions/variable";

type Role = {
  _id: any;
  name: string;
  permissions: string[];
  role: string;
};


export default function BsesRoles(): JSX.Element {
  const { toastNotify } = useContext(AppContext);

  // Create New User lightbox
  const [isOpen, setIsOpen] = useState(false);

  const [data, setData] = useState<Role[]>([]);
  const [modalData, setModalData] = useState<Role>();

  //Pagination
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [newPage, setNewPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };

  //   User Edit Modal
  const [isEditOpen, setIsEditOpen] = useState(false);
  const handleOpenEditModal = (item: Role) => {
    setIsEditOpen(true);
    setModalData(item);
  };

  const handleCloseEditModal = () => {
    setIsEditOpen(false);
    setModalData(undefined);
  };

  //View Modal
  const [isViewOpen, setIsViewOpen] = useState(false);
  const handleOpenViewModal = (item: Role) => {
    setIsViewOpen(true);
    setModalData(item);
  };

  const handleCloseViewModal = () => {
    setIsViewOpen(false);
    setModalData(undefined);
  };

  //   Delete Modal
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleOpenDeleteModal = () => {
    setIsDeleteOpen(true);
  };
  const handleCloseDeleteModal = () => {
    setIsDeleteOpen(false);
  };

  // User Table

  const [sortDir, setSortDir] = useState<"asc" | "desc">("asc");
  const [sortCol, setSortCol] = useState<"id" | "name" | "permissions">("id");

  const handleSort = (col: "id" | "name" | "permissions") => {
    if (sortCol === col) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortCol(col);
      setSortDir("asc");
    }
  };

  // Serch box
  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  // const handleGetRoles = async (currentP?: number, valu?: any) => {
  //   try {
  //     setLoading(true);
  //     let value = valu ? valu : search;
  //     let limit = Paginationlimit;
  //     let sort = 1;
  //     let page = currentP ? currentP : currentPage;
  //     const response: any = await appRequest("role", "get", {
  //       value,
  //       limit,
  //       sort,
  //       page,
  //     });
  //     if (response) {
  //       if (Array.isArray(response?.data)) {
  //         setData(response?.data);
  //         setTotalPages(response?.totalPages);
  //       } else {
  //         setData([]);
  //       }
  //       console.log(data);
  //     } else {
  //       toastNotify({
  //         title: `Error getting the roles and permissions.`,
  //         message: response.message || "Something went wrong.",
  //         type: "error",
  //       });
  //     }
  //   } catch (error: any) {
  //     toastNotify({
  //       title: `Error getting the roles and permissions.`,
  //       message: error.message || "Something went wrong.",
  //       type: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (initialLoad) {
  //     handleGetRoles(currentPage);
  //     setInitialLoad(false);
  //   } else {
  //     const debounceSearch = _.debounce((searchValue) => {
  //       handleGetRoles(currentPage, searchValue);
  //     }, 1000);
  //     debounceSearch(searchValue);
  //     return () => {
  //       debounceSearch.cancel();
  //     };
  //   }
  // }, [searchValue, currentPage]);
  const handleGetUserRoles = async (value: string = "") => {
    try {
      setLoading(true);
      const response: any = await appRequest("userrole", "get", { value });
      if (response) {
        if (Array.isArray(response)) {
          setData(response);
        } else {
          setData([]);
        }
      } else {
        toastNotify({
          title: `Error getting the roles and permissions.`,
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the roles and permissions.`,
        message: error.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialLoad) {
      handleGetUserRoles();
      setInitialLoad(false);
    } else {
      const debounceSearch = _.debounce((searchValue) => {
        handleGetUserRoles(searchValue);
      }, 1000);
      debounceSearch(searchValue);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [searchValue]);


  //Pagination
  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  return (
    <>
      <Box
        mt="1rem"
        boxShadow="rgb(0 0 0 / 12%) 0px 0px 11px"
        rounded={8}
        p="1.5rem 1.5rem"
        bg="white"
      >
        <Grid
          templateColumns={{ md: "1fr auto" }}
          alignItems="center"
          justifyContent="space-between"
          gap="1rem"
        >
          <Heading fontSize={{ base: "1.125rem", lg: "1.6rem" }}>
            <Button
              type="submit"
              bg="teal.300"
              h={"45px"}
              fontWeight="500"
              color="white"
              _hover={{
                bg: "teal.400",
              }}
              onClick={handleOpenModal}
            >
              Create New Roles
            </Button>
          </Heading>
          <Flex alignItems="center" gap="4">
            <Box w={{ base: "auto", lg: "15rem" }}>
              <SearchBox onSearch={handleSearch} />
            </Box>
            <Button
              border="2px solid"
              borderColor="teal.300"
              bg="white"
              fontSize="sm"
              color="teal.400"
              w={{ base: "auto", lg: "8rem" }}
              _hover={{ bg: "teal.300", color: "white" }}
              onClick={() => {
                handleGetUserRoles();
              }}
            >
              <HiOutlineRefresh fontSize="1.2rem" />
              <Text display={{ base: "none", lg: "block" }}>
                &nbsp; Refresh
              </Text>
            </Button>

            {/* <Button
              w="70px"
              bg="teal.300"
              color="white"
              _hover={{
                bg: "teal.400",
              }}
            >
              Sort
            </Button>
            <Button
              w="70px"
              bg="teal.300"
              color="white"
              _hover={{
                bg: "teal.400",
              }}
            >
              Limit
            </Button> */}
          </Flex>
        </Grid>
        <Box
          position="relative"
          overflow="auto hidden"
          className="customScrollBar"
        >
          <Table variant="striped" mt="1rem">
            <Thead>
              <Tr>
                <Th onClick={() => handleSort("name")}>
                  <Flex alignItems="center">
                    <Text mr={6}>Name</Text>
                    {sortCol === "name" &&
                      (sortDir === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
                  </Flex>
                </Th>
                <Th onClick={() => handleSort("permissions")}>
                  <Flex alignItems="center">
                    <Text mr={6}>Permissions</Text>
                    {sortCol === "permissions" &&
                      (sortDir === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
                  </Flex>
                </Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {loading === true ? (
                <Tr>
                  <Td colSpan={3}>
                    <Flex justify={"center"}>
                      <Spinner />
                    </Flex>
                  </Td>
                </Tr>
              ) : data.length === 0 ? (
                <Tr>
                  <Td colSpan={3}>
                    <Flex justify={"center"}>
                      <Text fontSize="sm">No Data Available to Show</Text>
                    </Flex>
                  </Td>
                </Tr>
              ) : (
                data.map((item, index) => (
                  <>
                    <Tr key={index}>
                      <Td>{item.name}</Td>
                      <Td>
                        <Tooltip
                          hasArrow
                          textAlign={"center"}
                          label={item.permissions.join("; ")}
                          maxW="350px"
                        >
                          <Text isTruncated w={"16rem"}>
                            {item.permissions.join("; ")}
                          </Text>
                        </Tooltip>
                      </Td>
                      <Td>
                        <Flex alignItems="center" justifyContent="end">
                          <Tooltip label="View Domain" hasArrow arrowSize={15}>
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              mr="2rem"
                              color="green.500"
                              onClick={() => handleOpenViewModal(item)}
                              _hover={{ color: "green.600" }}
                            >
                              <Box mr=".5rem" fontSize="1.4rem">
                                <AiFillEye />
                              </Box>
                              View
                            </Flex>
                          </Tooltip>
                          <Tooltip
                            label="Edit this role"
                            hasArrow
                            arrowSize={15}
                          >
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              mr="2rem"
                              color="green.500"
                              onClick={() => handleOpenEditModal(item)}
                              _hover={{ color: "green.600" }}
                            >
                              <Box mr=".5rem">
                                <FaEdit />
                              </Box>
                              Edit
                            </Flex>
                          </Tooltip>

                          <Tooltip
                            label="Delete this role"
                            hasArrow
                            arrowSize={15}
                          >
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              color="red.500"
                              mr="2rem"
                              onClick={handleOpenDeleteModal}
                              _hover={{ color: "red.600" }}
                            >
                              <Box mr=".5rem">
                                <RiDeleteBin5Line />
                              </Box>
                              Delete
                            </Flex>
                          </Tooltip>
                        </Flex>
                      </Td>
                    </Tr>
                    <DeleteModal
                      isProjects={false}
                      isUser={false}
                      isRole={true}
                      isOpen={isDeleteOpen}
                      handleUpdate={handleGetUserRoles}
                      onClose={handleCloseDeleteModal}
                      id={item._id}
                      request={{ type: "role", requestType: "delete" }}
                    />
                  </>
                ))
              )}
            </Tbody>
          </Table>
        </Box>
        {/* <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        /> */}
      </Box>
      <RolesModal
        isOpen={isOpen}
        onClose={handleCloseModal}
        handleGetUserRoles={handleGetUserRoles}
        type="Add"
      />

      <RolesModal
        isOpen={isEditOpen}
        onClose={handleCloseEditModal}
        data={modalData}
        handleGetUserRoles={handleGetUserRoles}
        type="Edit"
      />

      <RolesModal
        isOpen={isViewOpen}
        onClose={handleCloseViewModal}
        data={modalData}
        handleGetUserRoles={handleGetUserRoles}
        type="View"
      />
    </>
  );
}
